module.exports = __webpack_public_path__ + "static/media/under-maintenance2.a3a0b2cc.jpg";